import { getFieldOperators } from '@modules/queryBuilder/helpers/getFieldOperators';
import { getFilterValueFromSuggestion } from '@modules/queryBuilder/helpers/getFilterValueFromSuggestion';
import { QueryBuilderGroupOption } from 'generated/graphql';
import { v4 } from 'uuid';
import { UUID } from 'v2/core/entities/uuid';
import { OperatorHasAny } from 'v2/core/services/queryBuilder/operators';
import { NormalisedFilter } from 'v2/querybuilder/types/querystore';
import { getFilterValueType } from './getFilterValueType';

interface getFilterNodeFromSuggestionParams {
  option: QueryBuilderGroupOption;
  parent?: UUID;
}

export function getFilterNodeFromSuggestion({
  option,
  parent = '',
}: getFilterNodeFromSuggestionParams): NormalisedFilter {
  const operator =
    (option.field &&
      getFieldOperators({
        field: option.field.field,
        filterValueType: getFilterValueType(option.field),
      })?.[0]) ||
    OperatorHasAny;

  return {
    field: option?.field.field ?? '',
    id: v4(),
    type: 'filter',
    operator,
    value: getFilterValueFromSuggestion(option),
    parent,
  };
}
